import { render, staticRenderFns } from "./searchs.vue?vue&type=template&id=ca9ca236&scoped=true"
import script from "./searchs.vue?vue&type=script&lang=js"
export * from "./searchs.vue?vue&type=script&lang=js"
import style0 from "./searchs.vue?vue&type=style&index=0&id=ca9ca236&prod&lang=scss"
import style1 from "./searchs.vue?vue&type=style&index=1&id=ca9ca236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9ca236",
  null
  
)

export default component.exports